import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { BLOCK_UNBLOCK_SLOT } from "../dux/blockSlot";
import { fetchBookNowDetail } from "../dux/bookNow";
import { openSnackbar } from "../dux/snackbar";
import { getUpdateSlotsAllUrl } from "../helpers/apiEndPoints";

const blockSlot =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    if (action.type === BLOCK_UNBLOCK_SLOT) {
      const {
        sport,
        turf_number,
        date,
        location,
        block_time,
        unblock_time,
        duration,
      } = action.payload;
      next(apiCallStart({ api: "blockUnblock" }));
      next(
        apiAction({
          url: getUpdateSlotsAllUrl(),
          feature: BLOCK_UNBLOCK_SLOT,
          method: "PATCH",
          data: {
            sport,
            turf_number,
            slot_date: date,
            location,
            block_time,
            unblock_time,
            duration,
          },
          meta: { date, sport, location },
        })
      );
    }

    if (action.type === `${BLOCK_UNBLOCK_SLOT} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "blockUnblock" }));
      next(
        openSnackbar({
          message: "Slots have been blocked/unblocked successfully.",
        })
      );
      dispatch(
        fetchBookNowDetail({
          date: action.meta.date,
          sport: action.meta.sport,
          location: action.meta.location,
        })
      );
    }

    if (action.type === `${BLOCK_UNBLOCK_SLOT} ${API_ERROR}`) {
      next(apiCallComplete({ api: "blockUnblock" }));
    }
  };

export default blockSlot;
